import Image from "next/image";
import { H3, LinkButton, MarkdownRenderer } from "@/shared/components";
import { cn } from "@/lib/utils";

export interface MenuPromo {
  imageSrc: string | null;
  imageAlt: string;
  title: string | null;
  text: string | null;
  buttonLabel: string | null;
  buttonUrl: string | null;
}

export function hasMenuPromoContent(promo: MenuPromo | null | undefined): promo is MenuPromo {
  if (!promo) return false;
  return !!(promo.imageSrc || promo.title || promo.text || promo.buttonLabel);
}

interface MenuPromoBannerProps {
  promo: MenuPromo;
  className?: string;
}

const promoDescriptionClassName =
  "text-body text-primary-foreground [&_*]:text-inherit [&_p]:mb-0";

export function MenuPromoBanner({ promo, className }: MenuPromoBannerProps) {
  return (
    <div
      className={cn(
        "relative hidden w-[480px] shrink-0 self-stretch overflow-hidden desktop:block",
        !promo.imageSrc && "bg-muted",
        className
      )}
    >
      {promo.imageSrc && (
        <Image
          src={promo.imageSrc}
          alt={promo.imageAlt}
          fill
          className="object-cover"
          sizes="480px"
        />
      )}
      {promo.imageSrc && (
        <div className="absolute inset-0 bg-header-top/50" aria-hidden />
      )}
      <div className="relative flex h-full min-h-[320px] flex-col items-start justify-start gap-12 p-10 text-primary-foreground">
        {(promo.title || promo.text) && (
          <div className="flex w-full max-w-[400px] flex-col gap-4">
            {promo.title && (
              <H3 className="text-primary-foreground">
                {promo.title}
              </H3>
            )}
            {promo.text && (
              <MarkdownRenderer content={promo.text} className={promoDescriptionClassName} />
            )}
          </div>
        )}
        {promo.buttonLabel && (
          <LinkButton
            href={promo.buttonUrl || "#"}
            variant="default"
            size="sm"
            className="w-fit"
          >
            {promo.buttonLabel}
          </LinkButton>
        )}
      </div>
    </div>
  );
}
